import { PERMISSIONS } from "../../auth/permissions";

export class NavItem {
  name: string;
  link: string;
  show = true;
  permissions: PERMISSIONS[] = [];

  private constructor(name: string, link: string) {
    this.name = name;
    this.link = link;
  }

  static create(
    name: string,
    link: string,
    permissions: PERMISSIONS[] = [],
    show = true,
  ) {
    const item = new NavItem(name, link);
    item.show = show;
    item.permissions = permissions;
    return item;
  }
}
